export default __webpack_public_path__ + "static/media/beginning.97f032ed.yaml";